<template>
  <div class="waajo-ticket-detail-modal-root">
    <div
      v-if="visible"
      class="waajo-ticket-detail-modal-backdrop"
      @click.self="close"
    >
      <div class="waajo-ticket-detail-modal" role="dialog" aria-modal="true" aria-label="Detail Tiket">
        <div class="waajo-ticket-detail-modal-body">
          <ticket-detail-panel
            ref="panel"
            :ticket-id="ticketId"
            show-close
            @close="close"
            @loaded="handleLoaded"
            @updated="handleUpdated"
          />
        </div>

        <div class="waajo-ticket-detail-modal-footer">
          <button type="button" class="waajo-ticket-btn" @click="close">Tutup</button>
          <button
            type="button"
            class="waajo-ticket-btn is-primary"
            :disabled="!currentDetail"
            @click="openEdit"
          >
            <i class="fa fa-pencil"></i> Ubah Tiket
          </button>
        </div>
      </div>
    </div>

    <ticket-edit-modal
      :visible="showEdit"
      :ticket="currentDetail"
      @close="showEdit = false"
      @saved="handleEdited"
    />
  </div>
</template>

<script>
import TicketDetailPanel from './TicketDetailPanel.vue'
import TicketEditModal from './TicketEditModal.vue'

export default {
  name: 'TicketDetailModal',
  components: {
    TicketDetailPanel,
    TicketEditModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    ticketId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      currentDetail: null,
      showEdit: false
    }
  },
  watch: {
    visible(value) {
      if (!value) {
        this.showEdit = false
        this.currentDetail = null
      }
    }
  },
  methods: {
    close() {
      if (this.showEdit) return
      this.$emit('close')
    },
    handleLoaded(detail) {
      this.currentDetail = detail
    },
    handleUpdated(detail) {
      this.currentDetail = detail
      this.$emit('updated', detail)
    },
    openEdit() {
      if (!this.currentDetail) return
      this.showEdit = true
    },
    handleEdited(detail) {
      this.showEdit = false
      this.currentDetail = detail
      this.$emit('updated', detail)
      if (this.$refs.panel && this.$refs.panel.reload) {
        this.$refs.panel.reload()
      }
      this.$fire({
        title: 'Berhasil',
        text: 'Informasi tiket berhasil diperbarui.',
        type: 'success',
        timer: 2400,
        customClass: { container: 'waajo-swal-above-ticket-modal' },
        customContainerClass: 'waajo-swal-above-ticket-modal'
      })
    }
  }
}
</script>

<style scoped>
.waajo-ticket-detail-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2300;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
  background: rgba(15, 23, 42, 0.56);
}
.waajo-ticket-detail-modal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1120px;
  max-height: calc(100vh - 40px);
  overflow: hidden;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.26);
}
.waajo-ticket-detail-modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 22px 24px;
}
.waajo-ticket-detail-modal-footer {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 24px;
  border-top: 1px solid var(--waajo-border);
  background: var(--waajo-brand-soft-2);
}
.waajo-ticket-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 38px;
  padding: 0 16px;
  border: 1px solid #cbd5e1;
  border-radius: 9999px;
  background: #fff;
  color: var(--waajo-text-body);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}
.waajo-ticket-btn.is-primary {
  border-color: var(--waajo-brand);
  background: var(--waajo-brand);
  color: #fff;
  font-weight: 700;
  box-shadow: 0 7px 16px rgba(243, 156, 18, 0.24);
}
.waajo-ticket-btn.is-primary:hover,
.waajo-ticket-btn.is-primary:focus {
  border-color: var(--waajo-brand-strong);
  background: var(--waajo-brand-strong);
}
.waajo-ticket-btn:disabled {
  opacity: 0.6;
}
@media (max-width: 768px) {
  .waajo-ticket-detail-modal-backdrop {
    padding: 8px;
  }
  .waajo-ticket-detail-modal {
    max-height: calc(100vh - 16px);
    border-radius: 12px;
  }
  .waajo-ticket-detail-modal-body {
    padding: 16px;
  }
  .waajo-ticket-detail-modal-footer {
    padding: 12px 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ticket/components/TicketDetailModal.vue